import React, {Fragment} from 'react'
import _ from 'lodash';
import InspectionWrapper from '../../DisplayComponents/generic/InspectionWrapper'
import StaticMapDisplay from '../../DisplayComponents/StaticMapDisplay';


export default function ReviewMapSnapshot({reportState, saveReportForLater, handleChange, cancel, getMapImageCallback}){

    let {flexdata, loggedBMPs} = reportState;


	return(<>

		<InspectionWrapper
	      title="Review Map Picture"
	      navButtons={[
	        {
	          className: "btn-secondary", 
	          onClick: () => handleChange("phase", "TakeMapSnapshot"), 
	          label: <><i className="fa fa-camera mr-1"></i> RE-TAKE</>
	        },
	        {
	          className: "btn-outline-primary",
	          onClick: saveReportForLater,
	          label: "Save for Later"
	        },
	        {
	          className: "btn btn-primary",
	          onClick: () => handleChange("phase", "InspectionSummary"),
	          disabled: !reportState.mapImg,
	          label: <>Finish <i class="fa fa-angle-right ml-1"></i></>
	        }
	      ]}
	    >

        {reportState.mapImg ? 
			<StaticMapDisplay 
				reportState={reportState} 
			/> 
		:
			<div className="alert alert-warning position-static" role="alert">
				No map image has been saved. A map image is required to close out the inspection. Select Re-Take to capture it again.
			</div>
		}
		
		</InspectionWrapper>
	</>)
}